import React from 'react';
import { inputCls, Label, SelectIcon, ToggleYesNo } from './sharedVendorUI';
import CustomDatePicker from '../CustomDatePicker';

const ENTERPRISE_TYPES = ['Micro', 'Small', 'Medium'];
const MAJOR_ACTIVITIES = ['Manufacturing', 'Services', 'Traders'];

/**
 * MSME Applicable Yes/No toggle + the 5 conditional MSME fields, shared by both vendor forms.
 */
const MSMEFields = ({
    applicable, onApplicableChange,
    udyamNo, onUdyamNoChange,
    enterpriseType, onEnterpriseTypeChange,
    majorActivity, onMajorActivityChange,
    classificationDate, onClassificationDateChange,
    commencementDate, onCommencementDateChange,
    disabled,
}) => (
    <div>
        <div className="mb-6">
            <Label required>MSME Applicable</Label>
            <div className="max-w-xs">
                <ToggleYesNo value={applicable} onChange={onApplicableChange} disabled={disabled} />
            </div>
        </div>

        {applicable === 'Yes' && (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div>
                    <Label required>Udyam Registration Number</Label>
                    <input
                        type="text"
                        className={inputCls}
                        placeholder="Enter Udyam registration number"
                        value={udyamNo}
                        onChange={(e) => onUdyamNoChange(e.target.value)}
                        disabled={disabled}
                    />
                </div>
                <div>
                    <Label required>Enterprise Type</Label>
                    <div className="relative">
                        <select
                            className={`${inputCls} appearance-none pr-10`}
                            value={enterpriseType}
                            onChange={(e) => onEnterpriseTypeChange(e.target.value)}
                            disabled={disabled}
                        >
                            <option value="">-Please Select-</option>
                            {ENTERPRISE_TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
                        </select>
                        <SelectIcon loading={false} />
                    </div>
                </div>
                <div>
                    <Label required>Major Activity</Label>
                    <div className="relative">
                        <select
                            className={`${inputCls} appearance-none pr-10`}
                            value={majorActivity}
                            onChange={(e) => onMajorActivityChange(e.target.value)}
                            disabled={disabled}
                        >
                            <option value="">-Please Select-</option>
                            {MAJOR_ACTIVITIES.map((t) => <option key={t} value={t}>{t}</option>)}
                        </select>
                        <SelectIcon loading={false} />
                    </div>
                </div>
                <div>
                    <Label required>Classification Effective Date</Label>
                    <CustomDatePicker
                        value={classificationDate}
                        onChange={onClassificationDateChange}
                        disabled={disabled}
                        maxDate={new Date()}
                    />
                </div>
                <div>
                    <Label required>Date of Commencement of Business/Production</Label>
                    <CustomDatePicker
                        value={commencementDate}
                        onChange={onCommencementDateChange}
                        disabled={disabled}
                        maxDate={new Date()}
                    />
                </div>
            </div>
        )}
    </div>
);

export default MSMEFields;
